import { Injectable } from '@angular/core';
import { DataResponseHttp } from '../../../http-models/data-response.http';
import { DataResponseModel } from '../../../models/apis/data-response.model';
import { NotificationQueryHttp } from '../../../http-models/systems/notification/notification-query.http';
import { GetNotificationsPaginatedModel } from '../../../models/apis/system/notification/get-notifications-paginated.model';
import { NotificationQueryModel } from '../../../models/apis/system/notification/notification-query.model';
import { NotificationModel } from '../../../models/apis/system/notification/notification.model';
import { BaseMapperWithSerializer } from '../../base.mapper';

@Injectable({
    providedIn: 'root',
})
export class GetNotificationsPaginatedMapper
    implements
    BaseMapperWithSerializer<
            GetNotificationsPaginatedModel,
            string,
            DataResponseModel<NotificationQueryModel>,
            DataResponseHttp<NotificationQueryHttp>
        >
{
    convertTo(model: GetNotificationsPaginatedModel): string {
        let request = `?PageIndex=${model.pageIndex}&PageSize=${model.pageSize}`;
        if(model.filter){
            request += `&Filter=${model.filter}`;
        }
        return request;
    }

    convertFrom(
        http: DataResponseHttp<NotificationQueryHttp>
    ): DataResponseModel<NotificationQueryModel> {

        let response = {
            isError: http.isError,
            errors: http.errors
        } as DataResponseModel<NotificationQueryModel>;
        if(http.isError!=true && http.data){

            response.data = {
                pageIndex: http.data.pageIndex,
                pageSize: http.data.pageSize,
                totalPages: http.data.totalPages,
                totalRecords: http.data.totalRecords,
                isNextPageAvailable: http.data.isNextPageAvailable,
                sortBy: http.data.sortBy,
                sortOrder: http.data.sortOrder,
                notifications: []
            } as NotificationQueryModel;

            for(let itemHttp of http.data.notifications){
              let itemModel = {
                id: itemHttp.id,
                title: itemHttp.title,
                description: itemHttp.description,
                isRead: itemHttp.isRead,
                downloadFileUrl: itemHttp.downloadFileUrl,
                type: itemHttp.type,
                s3FileKey: itemHttp.s3FileKey,
                redirectUrl: itemHttp.redirectUrl,
                userId: itemHttp.userId,
                updatedBy: itemHttp.updatedBy,
                updatedDateUtc: new Date(itemHttp.updatedDateUtc)
              } as NotificationModel;
              response.data.notifications.push(itemModel);

            }
        }
        return response;
    }
}
